module.exports = __webpack_public_path__ + "static/img/原料泡泡-5.5764c27c.png";